import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form} from 'react-bootstrap';
import { ERROR_MESSAGES } from '../../data/ForgotPinConstants.js';
import { CODE_MISTMATCHED_ERROR } from '../../data/ConfirmCodeConstants.js';
import { Header } from '../header/header.js';
import { useTranslation } from 'react-i18next';
import './ChangePassword.css';
import '../auth/Spinner.css';
import Auth from "@aws-amplify/auth";
import { FiMail, FiEye, FiEyeOff } from 'react-icons/fi';

const ChangePassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [isLength, setIsLength] = useState(true);
    const [isMayus, setIsMayus] = useState(true);
    const [isLowercase, setIsLowercase] = useState(true);
    const [isNumber, setIsNumber] = useState(true);
    const [isSymbol, setIsSymbol] = useState(true);
    const [isMatch, setIsMatch] = useState(true);
    const [Touch, setTouch] = useState(false);
    const [Touched, setTouched] = useState({});
    const [code, setCode] = useState('');
    const [errors, setErrors] = useState('');
    const [lenguage, setLanguage] = useState('es');
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState('');
    const [messageStyle, setMessageStyle] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const onChangeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        if (!code.trim()) {
            newErrors.code = ERROR_MESSAGES.emptyField;
        } else {
            delete newErrors.code;
            setErrors(newErrors);
        }
        if (!password.trim()) {
            newErrors.password = ERROR_MESSAGES.emptyField;
        } else {
            delete newErrors.password;
            setErrors(newErrors);
        }
        if (!confirmPassword.trim()) {
            newErrors.confirmPassword = ERROR_MESSAGES.emptyField;
        } else {
            delete newErrors.confirmPassword;
            setErrors(newErrors);
        }
        if (Object.keys(newErrors).length > 0) {
            console.log(Object.keys(newErrors).length);
            setErrors(newErrors);
        } else {
            setIsLoading(true)
            const queryParams = new URLSearchParams(location.search);
            const username = queryParams.get('username');
            const token = queryParams.get('token');
            Auth.forgotPasswordSubmit(username, code, password)
                .then((data) => {
                    navigate(`/?token=${token}&status=sended`);
                })
                .catch((err) => {
                    setIsLoading(false);
                    setMessageStyle('errorPin');
                    setMessage(CODE_MISTMATCHED_ERROR);
                });
        }
    };
    const handleBlur = (field, value) => {
        if(value){
            setTouched((prevTouched) => ({...prevTouched, [field]: true }));
        }
    };
    const handleCodeChange = (e) => {
        const inputValue = e.target.value;
        const digitsOnly = /^\d*$/;
        if (digitsOnly.test(inputValue)) {
            setCode(inputValue);
        }
    };
    const handleChangePassword = (e) => {
        setErrors('');
        setIsValid(false);
        const { value } = e.target;
        setPassword(value);
        const requirements = (checkPasswordRequirements(value));
        setIsLength(requirements.hasLength);
        setIsMayus(requirements.hasUppercase);
        setIsLowercase(requirements.hasLowercase);
        setIsNumber(requirements.hasNumber);
        setIsSymbol(requirements.hasSymbol);
        setIsMatch(value === confirmPassword);
    };
    const handleChangeConfirmPassword = (e) => {
        setTouch(true);
        const { value } = e.target;
        setConfirmPassword(value);
        setIsMatch(value === password);
    };
    const checkPasswordRequirements = (password) => {
        const lengthRegex = /.{8,}/;
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const numberRegex = /\d/;
        const symbolRegex = /[-!$#%¡^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
        const hasLength = lengthRegex.test(password);
        const hasUppercase = uppercaseRegex.test(password);
        const hasLowercase = lowercaseRegex.test(password);
        const hasNumber = numberRegex.test(password);
        const hasSymbol = symbolRegex.test(password);
        return {
            hasLength,
            hasUppercase,
            hasLowercase,
            hasNumber,
            hasSymbol
        };
    }
    return (
        <Container fluid>
            <Header setLanguage={onChangeLanguage}/>
            <Row className="px-4 my-5 formLogin">
                <Col sm={4} className="resize">
                    <Form>
                    <h1>{t('h1NewPassword')}</h1>
                    {!message && <div className="sendedPin mb-3">{t('confirmDone')} <FiMail/></div>}
                    {message && <div className={messageStyle}>{t('codeMismatched')}</div>}
                    <Form.Group className="mb-5 mt-5 position-relative" controlId="formBasicText">
                                <Form.Label className="fit">{t('inputCode')}</Form.Label>
                                <Form.Control
                                    name="code"
                                    type="text"
                                    className="aditionalInfo"
                                    placeholder={t('placeholderCode')}
                                    value={code}
                                    onBlur={(e) => handleBlur('code', e.target.value)}
                                    onChange={(e) => handleCodeChange(e)}
                                    isInvalid={errors.code}
                                />
                                <Form.Control.Feedback className="error" type="invalid" tooltip>{t('emptyField')}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="password" className="mb-5 mt-5 position-relative">
                        <Form.Label className="fit"> {t('inputPassword')} </Form.Label>
                        <div className="password-input-wrapper">
                            <Form.Control
                            type={showPassword ? "text" : "password"} 
                            className="aditionalInfo"
                            placeholder={t('placeholderPass')}
                            value={password}
                            onChange={handleChangePassword}
                            onSubmit={handleSubmit}
                            isInvalid={errors.password}
                            />
                            <button 
                                type="button" 
                                className="password-toggle-btn" 
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </button>
                        </div>
                        {!isValid && !errors &&
                                <ul className="passReq">
                                    <li className={isLength ? 'validPass' : 'invalidPass'}> {t('isLength')} {isLength && <Form.Text className="validPass">&#x2713;</Form.Text>}</li>
                                    <li className={isMayus ? 'validPass' : 'invalidPass'}> {t('isMayus')} {isMayus && <Form.Text className="validPass">&#x2713;</Form.Text>}</li>
                                    <li className={isLowercase ? 'validPass' : 'invalidPass'}> {t('isLowercase')} {isLowercase && <Form.Text className="validPass">&#x2713;</Form.Text>}</li>
                                    <li className={isNumber ? 'validPass' : 'invalidPass'}> {t('isNumber')} {isNumber && <Form.Text className="validPass">&#x2713;</Form.Text>}</li>
                                    <li className={isSymbol ? 'validPass' : 'invalidPass'}> {t('isSymbol')} {isSymbol && <Form.Text className="validPass">&#x2713;</Form.Text>}</li>
                                </ul>
                        }
                        <Form.Control.Feedback className="error" type="invalid" tooltip>{t(`${errors.password}`)}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="confirmPassword" className="mb-3 position-relative">
                        <Form.Label className="fit"> {t('inputConfirmPass')} </Form.Label>
                        <div className="password-input-wrapper">    
                            <Form.Control
                            type={showPassword ? "text" : "password"} 
                            className="aditionalInfo mb-3"
                            placeholder={t('placeholderConfirmPass')}
                            value={confirmPassword}
                            onChange={handleChangeConfirmPassword}
                            isInvalid={errors.confirmPassword}
                            />
                            <button 
                                type="button" 
                                className="password-toggle-btn" 
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </button>
                        </div>
                        {Touch && !errors &&
                            <Form.Text className={isMatch ? 'validPass' : 'invalidPass'}>
                                {t('isMatch')} {isMatch && <Form.Text className="validPass">&#x2713;</Form.Text>}
                            </Form.Text>
                        }
                        
                        <Form.Control.Feedback className="error" type="invalid" tooltip>{t(`${errors.confirmPassword}`)}</Form.Control.Feedback>
                    </Form.Group>
                        <button className="btnLogin mt-3" type="submit" onClick={handleSubmit}>{t('btnRecoverPass')}</button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};
export default ChangePassword;